import {
  FacultyCard,
  LoadingListCard,
  PaginationList,
} from "Explore/Components";
import styles from "./UnitScholarAndPeers.module.scss";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useRef, useState } from "react";
import { Empty } from "antd";
import { getUnitFacultyById } from "Explore/Services/Unit";
import _ from "lodash";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

const grid = {
  gutter: [16, 16],
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
  xxl: 1,
};

const UnitScholarList = () => {
  const { unit_id } = useExploreInfo();
  const { selectedKeywords, timeFilter } =
    useSelector((state) => state.conceptState) || {};
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 30,
    totalRows: 0,
  });
  const prevFilter = useRef({});

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
      })
    ) {
      let newPagination = { ...pagination };
      if (
        _prevFilter.unit_id !== unit_id ||
        _prevFilter.selectedKeywords !== selectedKeywords ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage ||
        _prevFilter.timeFilter !== timeFilter
      ) {
        newPagination.page = 1;
      }

      setData({ data: [], isLoading: true });
      getUnitFacultyById({
        id: unit_id,
        keyword: selectedKeywords,
        timeFilter,
        page: newPagination.page - 1,
        rowsPerPage: newPagination.rowsPerPage,
      })
        .then((res) => {
          setData({ data: res.results, isLoading: false });
          setPagination({ ...newPagination, totalRows: res.total });
        })
        .catch(() => {
          setData({ data: [], isLoading: false });
          setPagination({ ...newPagination, totalRows: 0 });
        })
        .finally(() => {
          prevFilter.current = {
            unit_id,
            selectedKeywords,
            timeFilter,
            page: newPagination.page,
            rowsPerPage: newPagination.rowsPerPage,
          };
        });
    } else {
      prevFilter.current = {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
      };
    }
  }, [
    pagination.page,
    pagination.rowsPerPage,
    unit_id,
    selectedKeywords,
    timeFilter,
  ]);

  return (
    <div className={styles["list__wrapper"]}>
      <LoadingListCard
        isLoading={data.isLoading}
        grid={grid}
        componentNum={9}
        component={
          data.data.length === 0 ? (
            <Empty />
          ) : (
            <Grid container spacing="25px">
              {data.data.map((e, i) => (
                <Grid item md={12} key={i}>
                  <FacultyCard className={styles["entity-card"]} data={e} />
                </Grid>
              ))}
            </Grid>
          )
        }
      />
      <PaginationList pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default UnitScholarList;
